var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "submit-tags" },
    [
      _vm.loading ? _c("saving") : _vm._e(),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { id: "tag-editor-submit", type: "button" },
              on: { click: _vm.submit_tags },
            },
            [_vm._v("\n        Save tags\n    ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }